import { StatusPage } from '@data/components/composite/StatusPage/StatusPage';
import cliffordAdmin from '@data/assets/clifford-admin.png';

export function ComingSoonPage() {
  return (
    <StatusPage
      heading="Coming Soon..."
      description={
        <p>We&apos;re working on a new Dashboard experience for you!</p>
      }
      illustration={cliffordAdmin}
    />
  );
}
